import { Card, MultiSelect, SwitchInput } from 'corso-admin-ui';
import { automationsDisplayName, Pegasus, toEnum } from 'corso-types';
import { useMemo, useState } from 'react';
import { useAutomations } from '~/features/settings/hooks/useAutomations';
import AutomationRuleList from './AutomationsList';

export default function AutomationsAsList() {
  const returnOrWarrantyEventTypes = useMemo(
    () => [
      ...new Set(
        Pegasus.returnOrWarrantyHook.flatMap(
          (hook) => Pegasus.eventsForHook[hook],
        ),
      ),
    ],
    [],
  );

  const selectOptions = useMemo(
    () =>
      returnOrWarrantyEventTypes
        .filter((eventType) => !Pegasus.hiddenEvents.includes(eventType))
        .map((eventType) => ({
          label: automationsDisplayName.eventType[eventType],
          value: eventType,
        }))
        .sort((a, b) => a.label.localeCompare(b.label)),
    [returnOrWarrantyEventTypes],
  );

  const [selectedEventTypes, setSelectedEventTypes] = useState<
    Pegasus.EventType[]
  >(returnOrWarrantyEventTypes);

  const [showEnabledOnly, setShowEnabledOnly] = useState(true);
  const { data: automations } = useAutomations();

  return (
    <div className="space-y-4">
      <Card>
        <Card.Line>
          <Card.Heading>Filter</Card.Heading>
          <SwitchInput
            id="enabled-only"
            label="Show Only Enabled Automations"
            checked={showEnabledOnly}
            onChange={() => setShowEnabledOnly((prev) => !prev)}
          />
        </Card.Line>
        <MultiSelect
          clearable
          labelVisuallyHidden
          togglable
          onChange={(changed) =>
            setSelectedEventTypes(
              changed.map((option) => toEnum(option.value, Pegasus.EventType)),
            )
          }
          value={selectedEventTypes.map((eventType) => ({
            label: automationsDisplayName.eventType[eventType],
            value: eventType,
          }))}
          label="Event"
          options={selectOptions}
        />
        <AutomationRuleList
          label="Automations"
          sortBy="name"
          automations={automations
            .filter((automation) => !showEnabledOnly || automation.isEnabled)
            .filter((automation) =>
              selectedEventTypes.includes(
                toEnum(automation.rule.event.type, Pegasus.EventType),
              ),
            )}
        />
      </Card>
    </div>
  );
}
